<h3 class="ss-subtitle">Instruction</h3>
<div class="container">
  <div class="header">
    <object type="image/svg+xml" role="presentation" alt="" class="logo" data="assets/logos/savvas_logo.svg"></object>
    <span class="savvas-title">
      {{ title }}
    </span>
  </div>
  <div class="content">
    <div class="content-details">
      <span class="resources-title">Core Curriculum Resources</span>
      <span class="description">{{selectedStandardSet.instructionDescription}}</span>
    </div>
    <div class="content-actions">
      <a class="ren-btn ren-btn--secondary take-action"
        tabindex="0"
        [attr.aria-label]="buttonText +'(opens in a new tab)'"
        (click)="navigateToSavvas()" (keydown.enter)="navigateToSavvas()">
        <div class="resources-find-label"> {{ buttonText }} </div>
        <span class="glyph glyph-externallink margin-left-xsmall"></span>
      </a>
    </div>
  </div>
</div>
